import { useEffect, useCallback, useRef } from 'react';
import { COMPONENT_UNMOUNT_ABORT_ERROR_NAME } from 'util/errors';

/**
 * use this hook to produce signals used for aborts
 * which can help stop updating component state updates after unmounts
 */
function useAbortController() {
    const abortControllerRef = useRef<AbortController>();

    useEffect(() => {
        abortControllerRef.current = undefined;
        return () => abortControllerRef.current?.abort(COMPONENT_UNMOUNT_ABORT_ERROR_NAME);
    }, []);

    const getSignal = useCallback(() => {
        if (!abortControllerRef.current) {
            abortControllerRef.current = new AbortController();
        }
        return abortControllerRef.current.signal;
    }, []);

    return getSignal;
}

export default useAbortController;
